import { bootstrapApplication } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

config({ licenseKey: environment.devExtremeLicenseKey });

bootstrapApplication(App, appConfig).catch((err): void => console.error(err));
